<template>
  <div class="order-delivery">
    <h3 v-if="delivery && delivery.updated_at">物流记录 更新于{{formatTime(delivery.updated_at)}}</h3>
    <table class="table table-sm" v-if="delivery && delivery.records && delivery.records.length > 0">
      <thead>
        <tr>
          <th style="min-width: 14em">时间</th>
          <th>动态</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="record of delivery.records">
          <td>{{record.AcceptTime}}</td>
          <td>{{record.AcceptStation}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import LocalTime from '@/components/_small/LocalTime'
import {formatTime} from '@/utils/time'

export default {
  name: 'order-delivery',
  props: ['delivery'],
  data () {
    return {
    }
  },
  methods: {
    formatTime
  },
  components: {
    LocalTime
  }
}
</script>
